/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    StationOrLocationItem,
    StationOrLocationItemFromJSON,
    StationOrLocationItemFromJSONTyped,
    StationOrLocationItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupplierLocationMappingListItem
 */
export interface SupplierLocationMappingListItem {
    /**
     * 
     * @type {string}
     * @memberof SupplierLocationMappingListItem
     */
    id?: string;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof SupplierLocationMappingListItem
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {StationOrLocationItem}
     * @memberof SupplierLocationMappingListItem
     */
    oneAirLocation?: StationOrLocationItem;
    /**
     * 
     * @type {string}
     * @memberof SupplierLocationMappingListItem
     */
    supplierValue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {object}
     * @memberof SupplierLocationMappingListItem
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof SupplierLocationMappingListItem
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingListItem
     */
    allowEdit?: boolean;
}

export function SupplierLocationMappingListItemFromJSON(json: any): SupplierLocationMappingListItem {
    return SupplierLocationMappingListItemFromJSONTyped(json, false);
}

export function SupplierLocationMappingListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierLocationMappingListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'oneAirLocation': !exists(json, 'oneAirLocation') ? undefined : StationOrLocationItemFromJSON(json['oneAirLocation']),
        'supplierValue': !exists(json, 'supplierValue') ? undefined : json['supplierValue'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function SupplierLocationMappingListItemToJSON(value?: SupplierLocationMappingListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'oneAirLocation': StationOrLocationItemToJSON(value.oneAirLocation),
        'supplierValue': value.supplierValue,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'allowEdit': value.allowEdit,
    };
}


